<template>
  <div
    class="empty-no-login-sample height-all"
    :class="`empty-no-login-sample--${createRenderType}`"
  >
    <div class="empty-no-login-sample-content">
      <div
        class="empty-no-login-sample-title tc"
        v-if="createRenderType != 'mobile'"
      >
        {{ $$t("create.ai_songs_with_soft") }}
      </div>
      <div class="empty-no-login-sample-title tc" v-else>
        <p
          v-for="(i, index) in $$t('create.ai_songs_with_soft').split('\n')"
          :key="index"
        >
          {{ i }}
        </p>
      </div>
      <div class="empty-no-login-sample-list">
        <el-scrollbar v-if="createRenderType != 'mobile'">
          <div class="empty-no-login-sample-list-flex-content">
            <template v-for="(item, index) in props.datas" :key="index">
              <div class="empty-no-login-sample-item">
                <AudioItemNoOp :item="item" @togglePlay="doTogglePlay" />
              </div>
            </template>
          </div>
        </el-scrollbar>
        <div class="swiper" ref="refSwiper" v-else>
          <div class="swiper-wrapper">
            <div
              class="swiper-slide swiper-item"
              v-for="(item, index) in props.datas.concat(props.datas)"
              :key="index"
            >
              <div class="empty-no-login-sample-item">
                <AudioItemNoOp :item="item" @togglePlay="doTogglePlay" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"

import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue"
import AudioItemNoOp from "@/page/create/feedList/audioItemNoOp.vue"
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js"
import Swiper from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
const globalPlayDataStore = useGlobalPlayDataStore()

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const refSwiper = ref(null)
const props = defineProps({
  datas: {
    type: Array,
    default: () => {
      return []
    },
  },
})
const emits = defineEmits([])
const renderData = reactive({})
const doTogglePlay = (item) => {
  globalPlayDataStore.setCurPlayData(null)
}
onMounted(() => {
  const swiper = new Swiper(refSwiper.value, {
    slidesPerView: 3,
    centeredSlides: true,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    loop: true,
    autoplay: true,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 2,
      slideShadows: false,
    },
  })
})
</script>
<style lang="scss">
.empty-no-login-sample {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .swiper {
    z-index: unset;
  }
  .empty-no-login-sample-content {
    padding: 60px 0;
    max-height: 100%;
    overflow-y: scroll;
    max-width: 780px;
    width: 100%;
  }
  .empty-no-login-sample-title {
    font-family: HarmonyOS Sans SC;
    font-size: 36px;
    font-weight: 500;
    line-height: 48px;
    color: #ffffff;
  }

  .empty-no-login-sample-list {
    margin-top: 32px;
    display: flex;
  }
  .empty-no-login-sample-item {
    margin: 0 6px;
    min-width: 248px;
  }
  .empty-no-login-sample-list-flex-content {
    display: flex;
  }

  &.empty-no-login-sample--mobile {
    .empty-no-login-sample-content {
      padding: 30px 0px 100px 0px;
    }
    .empty-no-login-sample-list {
      margin-top: 32px;
      flex-direction: column;
      align-items: center;
      overflow-x: hidden;
      .empty-no-login-sample-item {
        margin: 32px 6px;
      }
    }
    .aicno-description {
      line-height: 20px;
    }
    .empty-no-login-sample-title {
      font-family: HarmonyOS Sans SC;
      font-size: 36px;
      line-height: 44px;
      font-weight: bold;
      color: #ffffff;
    }
    .swiper {
      width: 816px;
      margin: 0 auto 0 calc(50% - 408px);
      .swiper-wrapper{
        width: 816px;
      }
    }
    .swiper-slide {
      border-radius: 20px;
      background: linear-gradient(
        145deg,
        #1a3c8d 0%,
        #695bc5 47%,
        #3a1b6f 100%
      );
      transform: scale(0.9);
      transition: transform 0.3s ease-in-out;
      opacity: 0.5;
    }
    .swiper-slide-active {
      opacity: 1;
      transform: scale(1);
    }

    .el-carousel {
      height: 380px;
      width: 100%;
      .empty-no-login-sample-item {
        margin: 0;
        min-width: unset;
      }
    }
    .el-carousel__item {
      height: 380px;
      padding: 20px;
      min-width: 248px;
      border-radius: 20px;
      background: linear-gradient(
        145deg,
        #1a3c8d 0%,
        #695bc5 47%,
        #3a1b6f 100%
      );
      opacity: 0.5;

      &.is-in-stage {
        transform: translateX(-20px); /* 控制左右的卡片偏移 */
      }

      &.is-active {
        opacity: 1;
      }
    }
    .el-carousel__indicators {
      display: none;
    }
    .el-carousel__arrow {
      display: flex !important;
    }
  }
}
@media screen and (max-height: 730px) {
  .empty-no-login-sample {
    &.empty-no-login-sample--mobile {
      .empty-no-login-sample-content {
        padding: 10px 0px 80px 0px;
      }
      .empty-no-login-sample-title {
        font-size: 24px;
        line-height: 28px;
      }
      .empty-no-login-sample-list {
        margin-top: 16px;
        .empty-no-login-sample-item {
          margin: 20px 6px;
        }
        .aicno-description {
          font-size: 14px;
          line-height: 18px;
          min-height: 36px;
        }
        .aicno-card {
          margin: 8px 0;
          height: 120px;
          width: 120px;
        }
        .aicno-play-control {
          margin-top: 6px;
        }
        .el-button {
          height: 40px;
          i {
            height: 20px;
            width: 20px;
          }
        }
      }
    }
  }
}
.main-page-bottom-player-visible--true {
  .empty-no-login-sample {
    .empty-no-login-sample-content {
      padding-bottom: 100px;
    }
  }
}
</style>
